import { PrimitiveAtom, useSetAtom } from 'jotai';
import { Alert, AlertColor } from '@mui/material';
import { SnackbarMessage } from '@/types';
import { snackbarMessage as analysisSnackbarMessageAtom } from '@/components/Analysis/state';

type Props = {
  atom?: PrimitiveAtom<SnackbarMessage>;
  variant?: 'filled' | 'standard' | 'outlined';
};

export const useSnackBarMessage = ({
  atom = analysisSnackbarMessageAtom,
  variant = 'filled',
}: Props) => {
  const setSnackbarMessage = useSetAtom(atom);
  const showSnackBar = (message: string, severity: AlertColor) => {
    setSnackbarMessage({
      shouldShow: true,
      content: (
        <Alert
          sx={{ color: variant === 'standard' ? severity : 'white' }}
          variant={variant}
          severity={severity}
        >
          {message && (
            <>
              {message}
              &nbsp;&nbsp;
            </>
          )}
        </Alert>
      ),
    });
  };

  return {
    showSnackBar,
  };
};
